import { gql } from "urql";
export const GetSimpleEmailTemplatesQuery = gql `
    query GetSimpleEmailTemplates($offset: Int) {
        simpleEmailTemplates {
            simpleEmailTemplates(offset: $offset) {
                simpleEmailTemplateId
                organizationId
                subject
                body
                createdAt
                updatedAt
            }
            totalCount: simpleEmailTemplateCount
        }
    }
`;
export const GetSimpleEmailTemplateQuery = gql `
    query GetSimpleEmailTemplate($simpleEmailTemplateId: String!) {
        simpleEmailTemplates {
            simpleEmailTemplate(simpleEmailTemplateId: $simpleEmailTemplateId) {
                simpleEmailTemplateId
                organizationId
                subject
                body
                createdAt
                updatedAt
            }
        }
    }
`;
